import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/container/container.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/footer/footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/layout/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/SiteSettingsWrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Rubik\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-rubik\"}],\"variableName\":\"rubik\"}");
;
import(/* webpackMode: "eager", webpackExports: ["HashScrollFix"] */ "/vercel/path0/src/components/ui/hash-scroll-fix/hash-scroll-fix.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/src/components/ui/image/image.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/lib/contentful/ExperienceComponents.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/sass/styles.scss");
